import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { HOME_PATH, STORE_PATH } from '@/shared/config';
import { buttonVariants, SitePageShell } from '@/shared/ui';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 없는 주소(404) — 어떤 라우트에도 맞지 않을 때 보이는 공개 화면. */
export const NotFoundPage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-16 sm:pt-24">
    <div className="flex flex-col items-start gap-6">
      <p aria-hidden="true" className="font-display text-7xl leading-none sm:text-9xl">
        404
      </p>
      <div className="flex flex-col gap-3">
        <h1 className="text-[2rem] leading-[1.15] font-light tracking-[-0.03em] sm:text-5xl">
          페이지를 찾을 수 없어요
        </h1>
        <p className="text-sm text-muted-foreground">
          주소가 바뀌었거나 없어진 페이지예요. 주소를 다시 확인해 주세요.
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Link to={HOME_PATH} className={buttonVariants({ size: 'lg' })}>
          홈으로
        </Link>
        <Link to={STORE_PATH} className={buttonVariants({ variant: 'outline', size: 'lg' })}>
          스토어 둘러보기
        </Link>
      </div>
    </div>
  </SitePageShell>
);
